export const FETCH_ORDERS = "ORDER/FETCH_ORDERS";
export const FETCH_ORDERS_SUCCESS = "ORDER/FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "ORDER/FETCH_ORDERS_FAILURE";
export const SET_FITER_VALUES = "ORDER/SET_FITER_VALUES";

export const UPDATE_STATUS = "ORDER/UPDATE_STATUS";
export const UPDATE_STATUS_SUCCESS = "ORDER/UPDATE_STATUS_SUCCESS";
export const UPDATE_STATUS_FAILURE = "ORDER/UPDATE_STATUS_FAILURE";

export const UPDATE_PAYMENT_STATUS = "ORDER/UPDATE_PAYMENT_STATUS";
export const UPDATE_PAYMENT_STATUS_SUCCESS =
  "ORDER/UPDATE_PAYMENT_STATUS_SUCCESS";
export const UPDATE_PAYMENT_STATUS_FAILURE =
  "ORDER/UPDATE_PAYMENT_STATUS_FAILURE";

export const GET_ORDER_BY_ID = "ORDER/GET_ORDER_BY_ID";
export const GET_ORDER_BY_ID_SUCCESS = "ORDER/GET_ORDER_BY_ID_SUCCESS";
export const GET_ORDER_BY_ID_FAILURE = "ORDER/GET_ORDER_BY_ID_FAILURE";

export const SET_SELECTED_ORDERS = "ORDER/SET_SELECTED_ORDERS";
export const SET_SELECTED_ALL_ORDERS = "ORDER/SET_SELECTED_ALL_ORDERS";
export const SET_SELECTED_ORDER_PRODUCT = "PRODUCTS/SET_SELECTED_ORDER_PRODUCT";
export const CLEAR_SELECTED_ORDERS = "ORDER/CLEAR_SELECTED_ORDERS";
export const SET_SEARCH_VALUE = "ORDER/SET_SEARCH_VALUE";

export const CLEAR_SEELECTED_ORDER_PRODUCTS =
  "ORDER/CLEAR_SEELECTED_ORDER_PRODUCTS";
export const CLEAR_FILTER_VALUES = "ORDER/CLEAR_FILTER_VALUES";

export const REFUND_ORDER = "ORDER/REFUND_ORDER";
export const REFUND_ORDER_SUCCESS = "ORDER/REFUND_ORDER_SUCCESS";
export const REFUND_ORDER_FAILURE = "ORDER/REFUND_ORDER_FAILURE";

export const REFUND_PRODUCTS = "ORDER/REFUND_PRODUCTS";
export const REFUND_PRODUCTS_SUCCESS = "ORDER/REFUND_PRODUCTS_SUCCESS";
export const REFUND_PRODUCTS_FAILURE = "ORDER/REFUND_ORDER_FAILURE";

export const GET_SECTOR_BY_ID = "ORDER/GET_SECTOR_BY_ID";
export const GET_SECTOR_BY_ID_SUCCESS = "ORDER/GET_SECTOR_BY_ID_SUCCESS";

